export const getProviderDisplayName = (serviceName: string) => {
  switch (serviceName) {
    case 'GoogleDrive':
      return 'Google Drive';
    default:
      return serviceName;
  }
};
